import { useContext } from "react";
import TildeOk from "_+_Portal/assets/images/generico/TildeOk";
import BtnLink from "_+_Portal/_-_Autocheckin/components/genericos/BtnLink/BtnLink";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import { setCentroId } from "_+_Portal/_-_Autocheckin/context/action/atencionSinTurno";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import { ContainerPreguntarCentro } from "./localStyle";

const PreguntarCentro = () => {
  // -------------------------  context ----------------------------
  const { atencionSinTurnoState, pasoDispatch, atencionSinTurnoDispatch, ubicacionState } =
    useContext(AutocheckContext);
  // -------------------------  context ----------------------------

  // -------------------------  cosntants ----------------------------
  const centros = atencionSinTurnoState?.atencionSinTurno?.centros?.[0] ?? [];
  // -------------------------  cosntants ----------------------------

  // -------------------------  funciones ----------------------------
  const handleClickCentro = (centro) => {
    if (typeof centro.idCentro === "number") {
      setCentroId([[{ idCentro: centro.idCentro }]])(atencionSinTurnoDispatch);
      setPaso("AtencioSinTurno")(pasoDispatch);
    } else {
      setPaso("UbicacionSinTurno")(pasoDispatch);
    }
  };

  const eliminarDuplicados = (array) => {
    const seen = new Set();
    return array.filter((element) => {
      const duplicate = seen.has(element.idCentro);
      seen.add(element.idCentro);
      return !duplicate;
    });
  };

  // -------------------------  funciones ----------------------------

  return (
    <LayoutPasos
      title={"¿Se encuentra en dim?"}
      subtitle={"Indique en que centro se encuentra."}
      handleClick={() => {
        if (!ubicacionState?.ubicacion?.data) {
          setPaso("UbicacionSinTurno")(pasoDispatch);
        } else {
          setPaso("AtencionSinTurnoSelect")(pasoDispatch);
        }
      }}
    >
      <ContainerPreguntarCentro>
        {eliminarDuplicados(centros).length > 0
          ? eliminarDuplicados(centros).map((centro, key) => {
              return (
                <BtnLink
                  Icon={<TildeOk color={"var(--color-primary)"} />}
                  type={"NORMAL"}
                  title={centro.centro}
                  onclick={() => handleClickCentro(centro)}
                  key={key}
                />
              );
            })
          : ""}
      </ContainerPreguntarCentro>
    </LayoutPasos>
  );
};

export default PreguntarCentro;
